// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__letMl","clinicsSelect":"TableHeading_clinicsSelect__C2Jbo"};